import { Paper, Typography } from '@mui/material';
import { Box } from '@mui/system';
import Details, { defaultRenderArray } from './Details';
import { DetailsRow, HorizontalWrapperProps } from './types';


export const mapRefValuesToHorizontalDetails = (mappedRefValuesArrayForHorizontalDetails: 
  string[][], mappedRefValuesArray: DetailsRow[]) => 
  mappedRefValuesArrayForHorizontalDetails
    .map(z=> mappedRefValuesArray.filter(w=>z.includes(w.refValue as string)));


const HorizontalWrapper = (props: HorizontalWrapperProps) => {
  const { details, title, defaultStyle, marginLeft, 
    renderArrays=defaultRenderArray } = props;

  return (
    <>
      <Box display='flex'
        flexWrap='wrap' 
        sx={{
          marginLeft: marginLeft
            ? '10px'
            : '0px', 
          marginTop: defaultStyle
            ? '0px'
            : '26px'}}>
        <Paper variant='outlined' 
          sx={{ height: 'fit-content', width: '100%', borderRadius: 2, boxShadow: 0, backgroundColor: 'transparent'}}>
          {title
            ? <Typography m={2} variant='h3'>
              {title}
            </Typography>
            : null}  
          <Box m={1} display='flex' 
            gap={{xs: 0, md: 10}} 
            flexDirection={{xs: 'column', md: 'row'}}>
            {details.map((detail: any, index: any) => {
              return (
                <Details
                  renderArrays={renderArrays}
                  key={index}
                  removeLines
                  rows={detail}
                />
              );
            })}
          </Box>
        </Paper>
      </Box>
    </>);
};

export default HorizontalWrapper;